import React from 'react';
import { navigate } from 'gatsby';
import LocalizedLink from '../localizedLink';
import HelpCenterLinks from './helpCenterLinks';
import useTranslations from '../../utils/useTranslations';
import { LocaleContext } from '../layout';
import locales from '../../../config/i18n';
import arrowWhite from '../../images/icons/arrow-right.svg';
import baiWhite from '../../images/icons/bai-white.svg';

const MACOS_HELP_CENTER_CTA_LINK = 'https://chat.b.ai/chat?utm_source=bt';

const HelpCenterSearch = (props) => {
    const t = useTranslations(props.text);
    const { locale } = React.useContext(LocaleContext);

    function translateWithFallback(key, fallback) {
        const translated = t(key);
        return translated === key ? fallback : translated;
    }

    function handleSubmit(e) {
        if (e.key === 'Enter') {
            const path = `/help/search/?value=${encodeURIComponent(e.target.value)}`;
            const localizedPath = locales[locale].default ? path : `/${locales[locale].path}${path}`;
            navigate(localizedPath);
        }
    }

    return (
        <>
            <div className="help-center-search">
                <div className="search-container">
                    <div className="text">
                        <LocalizedLink to={HelpCenterLinks.homeLink} className="search-text">
                            <span className={'font-weight-bold'}>BitTorrent</span> {t('helpCenter')}
                        </LocalizedLink>
                    </div>
                    <div className="search-box">
                        <input
                            id="search"
                            className="search-input"
                            placeholder={t('searchPrompt')}
                            onKeyDown={handleSubmit}
                        />
                    </div>
                    <div className="macos-help-center-cta">
                        <div className="cta-content">
                            <img className="ai-icon" src={baiWhite} alt="B.AI" aria-hidden="true" />
                            <span className="cta-label">{translateWithFallback('askAiHome', 'Want to ask AI?')}</span>
                            <a
                                id="search-button"
                                href={MACOS_HELP_CENTER_CTA_LINK}
                                className="cta-go-pill btn-no-styling"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <span className="cta-go-label">{translateWithFallback('goButton', 'Go')}</span>
                                <img src={arrowWhite} alt="" aria-hidden="true" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HelpCenterSearch;
